import { api } from "@/services/api"
import type { MerchantCurrencyCode } from "@/utils/currency"
import { useQuery } from "@tanstack/vue-query"
import { parseISO } from "date-fns"

type ChartDataWeekStart = { weekStart: string }
type ChartDataType = {
  clientsTransacting: number
  revenue: number
  transactionCount: number
}

export type WeeklyTransactionChartData =
  ChartDataWeekStart & ChartDataType

export type WeeklyTransactionCountChartRow =
  ChartDataWeekStart &
    Pick<ChartDataType, "transactionCount">

type WeeklyTransactionChartDataType = Record<
  MerchantCurrencyCode,
  WeeklyTransactionChartData[]
>

type GetWeeklyTransactionChartResponse = {
  data: WeeklyTransactionChartDataType
  generatedAt: Date
}

const WEEKLY_TRANSACTION_CHART_DATA_TPPLUS_QUERY_KEY =
  "weekly_transaction_chart_data_tpplus"
const WEEKLY_TRANSACTION_CHART_DATA_BEEPAID_GO_QUERY_KEY =
  "weekly_transaction_chart_data_beepaid_go"

export const retrieveWeeklyTransactionChartDataTpplus =
  async (): Promise<GetWeeklyTransactionChartResponse> => {
    const { body } = await api.get<
      RecursivelyConvertDatesToStrings<GetWeeklyTransactionChartResponse>
    >("/transaction_summary_chart_data/weekly/tpplus")

    return {
      data: body.data,
      generatedAt: parseISO(body.generatedAt),
    }
  }

export const retrieveWeeklyTransactionChartDataBeepaidGo =
  async (): Promise<GetWeeklyTransactionChartResponse> => {
    const { body } = await api.get<
      RecursivelyConvertDatesToStrings<GetWeeklyTransactionChartResponse>
    >("/transaction_summary_chart_data/weekly/beepaid_go")

    return {
      data: body.data,
      generatedAt: parseISO(body.generatedAt),
    }
  }

export const useWeeklyTransactionChartDataTpplus = () =>
  useQuery({
    queryKey: [
      WEEKLY_TRANSACTION_CHART_DATA_TPPLUS_QUERY_KEY,
    ],
    queryFn: () =>
      retrieveWeeklyTransactionChartDataTpplus(),
    retry: 2,
  })

export const useWeeklyTransactionChartDataBeepaidGo = () =>
  useQuery({
    queryKey: [
      WEEKLY_TRANSACTION_CHART_DATA_BEEPAID_GO_QUERY_KEY,
    ],
    queryFn: () =>
      retrieveWeeklyTransactionChartDataBeepaidGo(),
    retry: 2,
  })
